export const pathSpecificCanonicalsMap = {
  '/amenities/luxury/': '/luxury/'
}
